// Session-scoped draft of unsaved offer form edits, keyed by offer id, so a forced re-auth
// (session expiry sign-out) doesn't lose the agent's in-progress work. Mirrors the read-once
// pattern of core/components/auth/oauth-storage.js.
const draftKey = (offerId) => `offer_form_draft:${offerId}`;

// Warn once per page, not per keystroke — LogRocket picks the console up for diagnosis
let warnedDraftSaveFailure = false;

const offerFormDraftStorage = {
  setDraft: (offerId, values) => {
    try {
      window.sessionStorage.setItem(draftKey(offerId), JSON.stringify(values));
    } catch (error) {
      // Storage full or blocked — the draft is best-effort, never break the form over it
      if (!warnedDraftSaveFailure) {
        warnedDraftSaveFailure = true;
        console.warn('Offer form draft not saved; edits will not survive a forced re-auth', error);
      }
    }
  },
  getDraft: (offerId) => {
    const draft = window.sessionStorage.getItem(draftKey(offerId));
    window.sessionStorage.removeItem(draftKey(offerId));
    if (!draft) {
      return null;
    }
    try {
      return JSON.parse(draft);
    } catch {
      return null;
    }
  },
  clearDraft: (offerId) => {
    window.sessionStorage.removeItem(draftKey(offerId));
  }
};

export default offerFormDraftStorage;
